import React from "react";

import Localize from "components/service/localize";
import TranslatedText from "components/service/translated-text";
import CraftTypeHelper from "../helpers/craft-type-helper";


const CraftTypeLabel = ({
        type,
        title,
        fallback = ""
    }) => {

    const localizeParams = CraftTypeHelper.localizeParams(type);

    if(localizeParams){
        return (
            <Localize { ...localizeParams.params }>
                { localizeParams.key }
            </Localize>
        );
    }

    if(!title) return fallback || null;

    return (
        <TranslatedText
            text={ title }
            namespace="craft-title"
            context={ `craft-title:${ type || title }` }
            fallback={ fallback }
        />
    );
};

export default CraftTypeLabel;
